import React from 'react';
import { Modal } from 'semantic-ui-react';
var AddToDesktopModal = function (props) { return (React.createElement(Modal, { centered: true, open: true, size: 'small', onClose: props.onClose, closeIcon: true },
    React.createElement(Modal.Content, { className: "text-center" },
        React.createElement("p", null, "The project will open in Neo4j Desktop in a few seconds if you have it installed..."),
        React.createElement("p", null,
            "Don't have Neo4j Desktop?",
            ' ',
            React.createElement("a", { target: "_blank", href: "https://neo4j.com/download/", onClick: function (e) { return window.neo4jSandbox.tracking.trackLinkClick(e); } }, "Download"),
            ' ',
            "it from here")))); };
export default AddToDesktopModal;
